import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { track } from '@tldraw/tldraw'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { ShapesDrawer } from 'components/Design/ShapesTab/ShapesDrawer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const DrawerContainer = track(
  observer(() => {
    const { isMobile } = useResponsiveDesign()
    const { drawersStore } = useRootStore()
    const editor = useEditor()
    const selectedShapeIds = editor.getSelectedShapeIds()
    const shapesDrawerOpen = drawersStore.drawers.find((d) => {
      return d.component.displayName === 'ShapesDrawer'
    })
    const showShapesDrawer = editor.isIn('select.idle') && selectedShapeIds.length > 0 && !shapesDrawerOpen

    useEffect(() => {
      if (!isMobile) return

      if (showShapesDrawer && !shapesDrawerOpen) {
        drawersStore.closeAllDrawers()
        drawersStore.openDrawer(ShapesDrawer)
      }

      if (selectedShapeIds.length === 0 && shapesDrawerOpen) {
        drawersStore.closeDrawer()
      }
    }, [showShapesDrawer, drawersStore, shapesDrawerOpen, selectedShapeIds, isMobile])

    return null
  }),
)

export { DrawerContainer }
